import { CheckCircle, PlayCircle, Lock, Circle } from 'lucide-react';

interface Lesson {
    id: string;
    title: string;
    completed: boolean;
}

interface LessonItemProps {
    lesson: Lesson;
    index: number;
    isActive: boolean;
    isLocked: boolean;
    onSelectLesson: (index: number) => void;
}

export function LessonItem({ lesson, index, isActive, isLocked, onSelectLesson }: LessonItemProps) {
    let icon;
    let itemClasses = "p-2 rounded-md text-sm flex items-center justify-between";
    const titleClasses = "";
    let clickable = true;

    if (lesson.completed) {
        icon = <CheckCircle size={16} className="text-green-500 flex-shrink-0"/>;
        itemClasses += " text-muted";
    } else if (isActive) {
        icon = <PlayCircle size={16} className="text-primary-600 flex-shrink-0"/>;
        itemClasses += " bg-primary-50 font-medium text-primary-700";
    } else if (isLocked) {
        icon = <Lock size={16} className="text-slate-400 flex-shrink-0"/>;
        itemClasses += " text-slate-400 cursor-not-allowed";
        clickable = false;
    } else {
        icon = <Circle size={16} className="text-slate-400 flex-shrink-0"/>;
        itemClasses += " text-foreground";
    }

    if (clickable) {
        itemClasses += " hover:bg-secondary cursor-pointer";
    }

    const handleClick = (e: React.MouseEvent) => {
        e.preventDefault();
        if (clickable) {
            onSelectLesson(index);
        }
    };

    return (
        <li>
            <a href="#" onClick={handleClick} className={itemClasses}>
                <div className="flex items-center min-w-0">
                    <span className="mr-2">{icon}</span>
                    <span className={`truncate ${titleClasses}`}>{lesson.title}</span>
                </div>
            </a>
        </li>
    );
}